module.exports = __webpack_public_path__ + "img/planta.5a57c7a1.png";